import React, { useCallback, useEffect } from 'react';
import { XIcon } from 'lucide-react';
import { Button } from './Button';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: ReactNode;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  showCloseButton?: boolean;
}
const sizeStyles = {
  sm: 'max-w-md',
  md: 'max-w-lg',
  lg: 'max-w-2xl',
  xl: 'max-w-4xl'
};
export function Modal({
  isOpen,
  onClose,
  title,
  children,
  size = 'md',
  showCloseButton = true
}: ModalProps) {
  const handleEscape = useCallback((e: KeyboardEvent) => {
    if (e.key === 'Escape') {
      onClose();
    }
  }, [onClose]);
  useEffect(() => {
    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, handleEscape]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 overflow-y-auto" aria-labelledby={title ? 'modal-title' : undefined} role="dialog" aria-modal="true" data-id="element-324">
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black/50 backdrop-blur-sm transition-opacity" onClick={onClose} aria-hidden="true" data-id="element-325" />

      {/* Modal container */}
      <div className="flex min-h-full items-center justify-center p-4" data-id="element-326">
        <div className={`
            relative w-full ${sizeStyles[size]} bg-white rounded-xl shadow-xl
            transform transition-all
          `} onClick={e => e.stopPropagation()} data-id="element-327">
          {/* Header */}
          {(title || showCloseButton) && <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200" data-id="element-328">
              {title && <h2 id="modal-title" className="text-lg font-semibold text-gray-900" data-id="element-329">
                  {title}
                </h2>}
              {showCloseButton && <Button variant="ghost" size="sm" onClick={onClose} className="ml-auto -mr-2" aria-label="Close modal" data-id="element-330">
                  <XIcon className="w-5 h-5" data-id="element-331" />
                </Button>}
            </div>}

          {/* Content */}
          <div className="px-6 py-4" data-id="element-332">{children}</div>
        </div>
      </div>
    </div>;
}